import React from "react";
import { useInView } from "react-intersection-observer";
const Tokenomics = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Only trigger once when the element comes into view
  });
  const files = [{ name: "WhitePaper", url: "/images/WhitePaper.pdf" }];
  const downloadFiles = () => {
    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  return (
    <>
      <section
        id="tokenomics"
        ref={ref}
        className={`Tokenomics ${inView ? "showcontent" : ""}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="content">
                <div className="left-content">
                  <div className="txt">
                    <h4>Front Pocket </h4>
                    <p>
                      $POCKET Tokenomics provides owners clarity about their
                      token ownership and how the token contributes to a pool of
                      capital accrued to the size of a large LP in our fund.
                      <b>
                        We will only offer 1000 coins to the market during
                        presale and launch
                      </b>
                      The coins in the presale will be scarce and they will be ½
                      price of launch day. The value of the token appreciates as
                      the impact of the fund grows.
                    </p>
                  </div>
                  <ul className="list-inline">
                    <li className="ecommerce">
                      <div>
                        <h3>Treasury Reserve</h3>
                        <label>40%</label>
                      </div>
                      <div>
                        <h4>2000 POCKET</h4>
                        <h5>Raised</h5>
                      </div>
                    </li>
                    <li
                      className="partnership"
                      style={{
                        padding: "10px", 
                        border: "2px solid transparent", 
                        borderRadius: "5px", 
                        boxShadow:
                          "0 0 5px #0a61cb, 0 0 10px #0a61cb, 0 0 15px #0a61cb, 0 0 20px #0a61cb", 
                        backgroundColor: "rgba(255, 255, 255, 0.1)", 
                      }}
                    >
                      <div>
                        <h3>Initial Supply</h3>
                        <label>20%</label> <br />
                        <h3>400 pre-sale/600 at ICO</h3>
                      </div>
                      <div>
                        <h4>1000 POCKET</h4>
                        <h5>Raised</h5>
                      </div>
                    </li>
                    <li className="fund">
                      <div>
                        <h3>Community Incentives</h3>
                        <label>20%</label>
                      </div>
                      <div>
                        <h4>1000 POCKET</h4>
                        <h5>Raised</h5>
                      </div>
                    </li>
                    <li className="advisory">
                      <div>
                        <h3>Partnerships</h3>
                        <label>10%</label>
                      </div>
                      <div>
                        <h4>500 POCKET</h4>
                        <h5>Raised</h5>
                      </div>
                    </li>
                    <li className="growth">
                      <div>
                        <h3>Development Fund</h3>
                        <label>10%</label>
                      </div>
                      <div>
                        <h4>500 POCKET</h4>
                        <h5>Raised</h5>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="right-content">
                  <div className="circle-content">
                    <img src="/images/graphcircle.png" alt="" />

                    <div className="sale">
                      <span>2000</span>
                      Treasury Reserve
                    </div>

                    <div className="growth">
                      <span>500</span>
                      Development Fund
                    </div>
                    <div className="public">
                      <span>500</span>
                      Partnerships
                    </div>
                    <div className="advisory">
                      <span>1000</span>
                      Community Incentives
                    </div>

                    <div className="partner">
                      <span>1000</span>
                      Initial Supply
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container" id="roadmap">
          <div className="row">
            <div className="col-12">
              <div className="Roadmap">
                <div className="image">
                  <img src="./images/roadmapback.png" alt="" />
                </div>
                <div className="roadmap-content">
                  <div className="heading">
                    <h4>Back Pocket </h4>
                    <p>
                      The fund is transparent in all we do. And our roadmap is
                      no different.
                    </p>
                  </div>
                  <div className="d-flex justify-content-start align-items-center pb-3 gap-3">
                    <button
                      className=" rounded subscribe"
                      onClick={downloadFiles}
                      style={{
                        background: "#0a61cb",
                        border: "1px solid #0a61cb",
                        fontSize: "16px",
                        padding: "14px 20px",
                        textAlign: "center",
                        fontFamily: '"Inter", serif',
                        fontWeight: "600",
                        lineHeight: "22px",
                        color: "#fff",
                      }}
                    >
                      Whitepaper
                    </button>
                    <a
                      href="https://etherscan.io/address/0x1685968d83808322530c7110174ffc5c41fc07b5#code"
                      target="_blank"
                    >
                      <button
                        className="rounded subscribe"
                        style={{
                          background: "#0a61cb",
                          border: "1px solid #0a61cb",
                          fontSize: "16px",
                          padding: "14px 20px",
                          textAlign: "center",
                          fontFamily: '"Inter", serif',
                          fontWeight: "600",
                          lineHeight: "22px",
                          color: "#fff",
                        }}
                      >
                        Pre-sale Contract Address
                      </button>
                    </a>
                  </div>
                  <ul className="timeline list-inline">
                    <li
                      className="q1"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Q1 2025</h4>
                      {/* <h5>Development and Testing:</h5> */}
                      <p>The $POCKET ecosystem presale and launch</p>
                    </li>
                    <li
                      className="q2"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Q2 2025</h4>
                      {/* <h5>Pre-sale:</h5> */}
                      <p>
                        Onboard token holders, form a DAO (including folks from
                        prestigious universities), introduce governance. Folks
                        will login and see the real-time view of the fund’s
                        activity!
                      </p>
                    </li>
                    <li
                      className="q3"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Q3 2025</h4>
                      {/* <h5>Public Launch</h5> */}
                      <p>
                        With all the initial 1000 tokens sold, and a DAO
                        established, Pocket Ventures will support a first
                        placement recommended by the DAO.
                      </p>
                    </li>
                    <li
                      className="q4"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Q4 2025</h4>
                      {/* <h5>Mainnet Launch</h5> */}
                      <p>
                        Introduce incentive structures. Token awards! Refine
                        governance based on lessons learned. Gather community
                        feedback to shape the roadmap for the following year
                      </p>
                    </li>
                    {/* <li
                      className="q5"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 5:</h4>
                      <h5>Ecosystem Expansion</h5>
                      <p>
                        Expand the ecosystem by partnering with other projects
                        and businesses.
                      </p>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tokenomics;
